export default {"src":"/_next/static/media/unapprovedAccBanner.81a05e21.svg","height":20,"width":20};